export default "__VITE_PUBLIC_ASSET__f11fd33f__"